import React, { useState, useEffect } from "react";
import ListadoProducto from "./ListadoProducto";
import BarraParaOrdenar from "./BarraParaOrdenar";
import SeccionIzquierda from "./SeccionIzquierda";
import { productosAPI, toolsAPI } from "../../utils/funcionesAPI";
import PropTypes from "prop-types";
import Loader from "../Global/Loader.js";
import { manejadorDeRespuesta, stockEnDemanda } from "../../utils/Tools";
import { toast, ToastContainer } from "react-toastify";
import Breadcrumbs from "./breadcrumbs";
import Titulo from "./titulo";
import FiltrosBusqueda from "./filtrosBusqueda.js";

const Resultados = (props) => {
  const { pasajerosAdultos, match } = props;

  const {
    origen,
    destino,
    fecha,
    idProducto,
    idGrupo,
    nombreGrupo,
    promociones,
    idCharter,
    provincia,
    idPuntoDeEmbarque,
  } = match.params;

  const [productosEncontrados, setProductosEncontrados] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [esSoloYSolas, setEsSoloYSolas] = useState(
    idGrupo === "7" || idGrupo === "14" ? true : false
  );

  const [provinciasDeBarraOrdenar, setProvinciasDeBarraOrdenar] = useState([]);
  const [provinciaElegidaDeBarraOrdenar, setProvinciaElegidaDeBarraOrdenar] =
    useState({
      puntosDeEmbarque: [],
      denominacion: "Saliendo desde",
    });
  const [puntoDeEmbarqueDeBarraOrdenar, setPuntoDeEmbarqueDeBarraOrdenar] =
    useState({
      idPuntoDeEmbarque: 0,
      denominacion: "Paradas Que Podes Elegir",
    });

  const traerProductosBuscados = (origen, destino, fecha, pasajeros = []) => {
    // FC: traer prod por orig, des, fecha
    const data = JSON.stringify({
      peticion: "traerProductosBuscadosParaWeb",
      origen,
      destino,
      fecha,
      adultos: pasajeros.length,
      canal: "WEB",
    });
    setLoaded(false);
    productosAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        setLoaded(true);
        setProductosEncontrados(respuesta.data);
      }
    });
  };

  const traerProductosBuscadosPorPuntoDeEmbarque = (
    origen,
    destino,
    fecha,
    puntoDeEmbarque,
    pasajeros = []
  ) => {
    // FC: traer prod por orig, des, fecha
    const data = JSON.stringify({
      peticion: "traerProductosPorOrigenDestinoFechaPuntoEmbarque",
      origen,
      destino,
      fecha,
      adultos: pasajeros.length,
      canal: "WEB",
      idPuntoDeEmbarque: puntoDeEmbarque,
    });
    setLoaded(false);
    productosAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        setLoaded(true);
        setProductosEncontrados(respuesta.data);
      }
    });
  };

  const traerProductosPorGrupo = (
    peticion,
    origen,
    destino,
    fecha,
    idPuntoDeEmbarque,
    idGrupo,
    pasajeros = []
  ) => {
    const data = JSON.stringify({
      peticion,
      idGrupo,
      origen,
      adultos: pasajeros.length,
      destino,
      fecha,
      idPuntoDeEmbarque,
      canal: "WEB",
    });
    setLoaded(false);
    productosAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        setProductosEncontrados(respuesta.data);
        setLoaded(true);
      }
    });
  };

  const traerProductosValijaYa = (
    peticion,
    origen,
    idPuntoDeEmbarque,
    pasajeros = []
  ) => {
    const data = JSON.stringify({
      peticion,
      origen,
      idPuntoDeEmbarque,
      adultos: pasajeros.length,
      canal: "WEB",
      soloValijaYa: true,
    });
    setLoaded(false);
    productosAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        let productos = respuesta.data;
        for (let i = 0; i < productos.length; i++) {
          if (productos[i].charters.length === 0) {
            productos.splice(i, 1);
          }
        }
        setProductosEncontrados(productos);
        setLoaded(true);
      }
    });
  };

  const traerOrigenParaGrupos = (id) => {
    let data = JSON.stringify({
      accion: "traerOrigenParaGrupos",
      idGrupo: id,
    });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        setProvinciasDeBarraOrdenar(respuesta.data);
      }
    });
  };

  const traerOrigenParaValijaYa = () => {
    let data = JSON.stringify({
      accion: "traerOrigenParaValijaYa",
    });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta)) {
        setProvinciasDeBarraOrdenar(respuesta.data);
      }
    });
  };

  //separe logica de solos y solas para evitar loop infinito
  useEffect(() => {
    stockEnDemanda(9);
    if (esSoloYSolas) {
      handleAdultosChange(1);
      traerProductosPorGrupo(
        "traerProductosPorGrupoParaWeb",
        origen,
        destino,
        fecha,
        idPuntoDeEmbarque,
        idGrupo,
        pasajerosAdultos
      );
    }

    if (idGrupo) {
      props.onSelectTipoBusquedaChange("porDestino");
      traerOrigenParaGrupos(idGrupo);
    }

    if (promociones) {
      traerOrigenParaValijaYa();
    }

    if (destino === "LMG") {
      toast.info(
        "Aguarde unos instantes y será redirigido al sitio de La Estancia Margarita.",
        {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 5000,
          onClose: () => {
            window.location.href = "https://estanciamargarita.com.ar/";
          },
        }
      );
    }
  }, []);

  useEffect(() => {
    if (!esSoloYSolas) {
      if (idGrupo) {
        traerProductosPorGrupo(
          "traerProductosPorGrupoParaWeb",
          origen,
          destino,
          fecha,
          idPuntoDeEmbarque,
          idGrupo,
          pasajerosAdultos
        );
      } else if (promociones) {
        traerProductosValijaYa(
          "traerProductosValijaYaParaWeb",
          origen,
          "0",
          pasajerosAdultos
        );
      } else if (idPuntoDeEmbarque) {
        traerProductosBuscadosPorPuntoDeEmbarque(
          origen,
          destino,
          fecha,
          idPuntoDeEmbarque,
          pasajerosAdultos
        );
        props.onLoadEstadoInicial(
          fecha,
          destino,
          origen,
          provincia,
          idPuntoDeEmbarque,
          pasajerosAdultos
        );
      } else {
        traerProductosBuscados(origen, destino, fecha, pasajerosAdultos);
        props.onLoadEstadoInicial(fecha, destino, origen);
      }
    }
  }, [
    origen,
    destino,
    fecha,
    idGrupo,
    promociones,
    idPuntoDeEmbarque,
    pasajerosAdultos,
  ]);

  const mostrarNombreDestino = (codigo) => {
    if (props.busqueda.destinos.length === 0) return "";
    const destino = props.busqueda.destinos.find(
      (destino) => destino.idDestino === codigo
    );
    if (!destino) return "Destino no encontrado";

    return destino.descripcion;
  };

  const handleProductoClick = (producto) => {
    props.onProductoClick(producto);
  };

  const handleCharterClick = (charter) => {
    props.onCharterClick(charter);
  };

  const handleOrdenarClick = (e) => {
    let productosEncontradosLocal = productosEncontrados.slice(); //creating copy of object

    if (e.target.name === "menor") {
      productosEncontradosLocal.sort((a, b) => {
        if (a.tarifaPorHabitacion || b.tarifaPorHabitacion) return true;
        a.tarifas[0].tarifaNeta - b.tarifas[0].tarifaNeta;
      });
    } else {
      productosEncontradosLocal.sort((a, b) => {
        if (a.tarifaPorHabitacion || b.tarifaPorHabitacion) return true;
        b.tarifas[0].tarifaNeta - a.tarifas[0].tarifaNeta;
      });
    }
    setProductosEncontrados(productosEncontradosLocal);
  };

  const handlePosicionarPorTransporte = (idProducto) => {
    document.getElementById(idProducto).scrollIntoView(false);
  };

  //FC eventos del Buscador
  const handleCombosBusquedaChange = (propiedad, valor) => {
    props.onSelectChange(propiedad, valor);
  };

  const handleCombosOrigenBusquedaChange = (origen) => {
    props.onSelectOrigenChange(origen);
  };

  const handleCombosDestinoBusquedaChange = (destino) => {
    props.onSelectDestinoChange(destino);
  };

  const handleComboPeriodoBusquedaChange = (
    fecha,
    destino,
    codigoProvinciaOrigen,
    idPuntoDeEmbarque
  ) => {
    props.onSelectPeriodoChange(
      fecha,
      destino,
      codigoProvinciaOrigen,
      idPuntoDeEmbarque
    );
  };

  const handleComboEmbarqueBusquedaChange = (embarque) => {
    props.onSelectEmbarqueBusquedaChange(embarque);
  };

  const handleRadioCambiarTipoBusquedaChange = (value) => {
    props.onSelectTipoBusquedaChange(value);
  };

  const handleAdultosChange = (cantidad) => {
    props.onAdultosChange(cantidad);
  };

  const handleMenoresChange = (fecha) => {
    props.onMenoresChange(fecha);
  };

  const handleEdadChange = (clave, valor) => {
    props.onEdadChange(clave, valor);
  };

  const handleSelectorEmbarqueChange = (idEmbarqueSeleccionado) => {
    const puntoDeEmbarqueElegido =
      provinciaElegidaDeBarraOrdenar.puntosDeEmbarque.find(
        (emb) => emb.idPuntoDeEmbarque === idEmbarqueSeleccionado
      );
    setPuntoDeEmbarqueDeBarraOrdenar(puntoDeEmbarqueElegido);
    traerProductosPorGrupo(
      "traerProductosPorGrupoConEmbarque",
      puntoDeEmbarqueElegido.sucursal,
      null,
      null,
      puntoDeEmbarqueElegido.idPuntoDeEmbarque,
      idGrupo,
      pasajerosAdultos
    );
  };

  const handleSelectorValijaYaEmbarqueChange = (idEmbarqueSeleccionado) => {
    const puntoDeEmbarqueElegido =
      provinciaElegidaDeBarraOrdenar.puntosDeEmbarque.find(
        (emb) => emb.idPuntoDeEmbarque === idEmbarqueSeleccionado
      );
    setPuntoDeEmbarqueDeBarraOrdenar(puntoDeEmbarqueElegido);
    traerProductosValijaYa(
      "traerProductosValijaYaConEmbarque",
      puntoDeEmbarqueElegido.sucursal,
      puntoDeEmbarqueElegido.idPuntoDeEmbarque,
      pasajerosAdultos
    );
  };

  const handleProvinciaEnFiltroChange = (prov) => {
    //const provEncontrada = provinciasDeBarraOrdenar.find()
    setProvinciaElegidaDeBarraOrdenar(prov);
    setPuntoDeEmbarqueDeBarraOrdenar({
      idPuntoDeEmbarque: 0,
      denominacion: "Elegí Donde Subir",
    });
  };

  const handleLimpiarFiltrosButton = () => {
    setProvinciaElegidaDeBarraOrdenar({
      puntosDeEmbarque: [],
      denominacion: "Saliendo desde",
    });
    setPuntoDeEmbarqueDeBarraOrdenar({
      idPuntoDeEmbarque: 0,
      denominacion: "Elegí Donde Subir",
    });

    if (promociones) {
      traerProductosValijaYa(
        "traerProductosValijaYaParaWeb",
        origen,
        idPuntoDeEmbarque,
        pasajerosAdultos
      );
      return;
    }

    traerProductosPorGrupo(
      "traerProductosPorGrupoParaWeb",
      origen,
      destino,
      fecha,
      idPuntoDeEmbarque,
      idGrupo,
      pasajerosAdultos
    );
  };

  //const destino = this.props.match.params.destino;
  //const fecha = this.props.match.params.fecha;
  //const idProducto = this.props.match.params.idProducto;
  //asociarImagenes(productosEncontrados);
  //console.log(destinosJSON);

  return (
    <section id="main-content" className="main">
      <div className="container-fluid">
        <Breadcrumbs
          nombreDestino={mostrarNombreDestino(destino)}
          destino={destino}
        />
        <Titulo
          nombreDestino={mostrarNombreDestino(destino)}
          destino={destino}
          idGrupo={idGrupo}
          nombreGrupo={nombreGrupo}
          promociones={promociones}
          cantidadProductos={productosEncontrados.length}
          origen={origen}
          fecha={fecha}
          puntoDeEmbarque={props.busqueda.puntoDeEmbarque}
        />

        <div className="row">
          <SeccionIzquierda
            busqueda={props.busqueda}
            onSelectChange={handleCombosBusquedaChange}
            onSelectOrigenChange={handleCombosOrigenBusquedaChange}
            onSelectDestinoChange={handleCombosDestinoBusquedaChange}
            onSelectPeriodoChange={handleComboPeriodoBusquedaChange}
            onSelectEmbarqueBusquedaChange={handleComboEmbarqueBusquedaChange}
            onSelectTipoBusquedaChange={handleRadioCambiarTipoBusquedaChange}
            onAdultosChange={handleAdultosChange}
            onMenoresChange={handleMenoresChange}
            onEdadChange={handleEdadChange}
            solosYsolas={esSoloYSolas}
          />
          <article className="col-xl-9 col-lg-9 col-md-9 col-sm-6 col-12 show-results">
            <BarraParaOrdenar
              onClickOrdenar={handleOrdenarClick}
              posicionarEn={handlePosicionarPorTransporte}
              solosYsolas={esSoloYSolas}
              destino={destino}
              productos={productosEncontrados}
            />
            {(idGrupo || promociones) && (
              <FiltrosBusqueda
                provinciasDeBarraOrdenar={provinciasDeBarraOrdenar}
                provinciaElegidaDeBarraOrdenar={provinciaElegidaDeBarraOrdenar}
                puntoDeEmbarqueDeBarraOrdenar={puntoDeEmbarqueDeBarraOrdenar}
                setProvinciaElegidaDeBarraOrdenar={
                  setProvinciaElegidaDeBarraOrdenar
                }
                onSelectorEmbarqueChange={
                  idGrupo
                    ? handleSelectorEmbarqueChange
                    : handleSelectorValijaYaEmbarqueChange
                }
                onLimpiarFiltrosButton={handleLimpiarFiltrosButton}
                onProvinciaFiltrosChange={handleProvinciaEnFiltroChange}
              />
            )}
            <Loader
              loaded={loaded}
              mensaje="Buscando Paquetes, aguarde unos instantes..."
            />
            {destino === "LMG" && (
              <div className="loader row result">
                <h3>
                  Para reservar en La Estancia Margarita deberá ingresar al
                  sitio oficial de La Estancia en{" "}
                  <a
                    href="https://estanciamargarita.com.ar/"
                    style={{ fontStyle: "bold", color: "blue" }}
                  >
                    https://estanciamargarita.com.ar/
                  </a>{" "}
                  o aguarde unos instantes y será redirigido
                </h3>
              </div>
            )}
            {productosEncontrados.length === 0 &&
              loaded &&
              destino !== "LMG" && (
                <div className="loader row result">
                  <h3>
                    No se han encontrado Paquetes. Por favor pruebe buscando
                    desde otra salida u otro periodo.
                  </h3>
                </div>
              )}
            {loaded && (
              <ListadoProducto
                origen={origen}
                destino={destino}
                fecha={fecha}
                productos={productosEncontrados}
                idProducto={idProducto}
                onProductoClick={handleProductoClick}
                onCharterClick={handleCharterClick}
                idCharterDeURL={idCharter}
                solosYsolas={esSoloYSolas}
                pasajerosAdultos={pasajerosAdultos}
                promociones={promociones}
                esGrupoComercial={idGrupo}
                idPuntoDeEmbarque={idPuntoDeEmbarque}
                idPuntoDeEmbarqueDeBarraOrdenar={
                  puntoDeEmbarqueDeBarraOrdenar.idPuntoDeEmbarque
                }
              />
            )}
          </article>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default Resultados;

Resultados.propTypes = {
  onProductoClick: PropTypes.func.isRequired,
  onCharterClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Resultados/index.js